import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const PAYMENT_PROCESSOR = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            customerProfileId: 'customerProfileId'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            customerProfileId: 'cpi'
        })
    })
})()

export const PREFERRED_CARD = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            cardId: 'cardId'
        }),
        [MODE_PROD]: Object.freeze({
            cardId: 'ci'
        })
    })
})()

export const USERS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            createdAt: 'createdAt',
            email: 'email',
            firstName: 'firstName',
            lastName: 'lastName',
            DOB: 'DOB',
            phoneNumber: 'phoneNumber',
            preferredAddress: 'preferredAddress',
            preferredCard: 'preferredCard',
            provinceId: 'provinceId',
            notificationToken: 'notificationToken',
            paymentProcessor: 'paymentProcessor',
            isDisabled: 'isDisabled'
        }),
        [MODE_PROD]: Object.freeze({
            createdAt: 'ca',
            email: 'e',
            firstName: 'fn',
            lastName: 'ln',
            DOB: 'd',
            phoneNumber: 'pn',
            preferredAddress: 'pa',
            preferredCard: 'pc',
            provinceId: 'pi',
            notificationToken: 'nt',
            paymentProcessor: 'pp',
            isDisabled: 'id'
        })
    })
})()
